<template>
  <q-icon
    class="q-ml-xs"
    :name="formattedDateComponent.modeIconName"
    @click.stop="formattedDateComponent.cycleTimeZoneMode"
  >
    <q-tooltip>
      {{ $_.startCase(formattedDateComponent.timezoneMode.value) }} Time
    </q-tooltip>
  </q-icon>
</template>

<script>

export default {
  name: 'FormattedDateModeIcon',
  props: {
    formattedDateComponent: {
      type: Object,
      required: true
    }
  }
}
</script>
